// extracted by mini-css-extract-plugin
export default {"PriceListItem":"PriceListItem_PriceListItem__lyi9X"};